export default headers => headers['x-channel'] === 'bixby';
